import React from "react";

import { SpacerBlock as Value } from "@reactivated";

import { AbstractSpacerBlock } from "@thelabnyc/thelabui/src/components/SpacerBlock";
import labuiStyles from "@thelabnyc/thelabui/src/components/SpacerBlock/index.module.scss";
import { pApplyProps } from "@thelabnyc/thelabui/src/utils/react";

import xcientStyles from "./index.module.scss";

const { contrast, match, ...extraSpacerStyles } = xcientStyles;

const BaseSpacerBlock = pApplyProps(AbstractSpacerBlock, {
    heightClasses: { ...labuiStyles, ...extraSpacerStyles },
});

export const SpacerBlock = ({ value }: { value: Value }) => {
    if (!value.height) return <></>;
    const themeClass = xcientStyles[value.theme ?? "match"];

    return <BaseSpacerBlock value={value} className={themeClass} />;
};
